"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("./index.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var couponFrom = {};
couponFrom.install = function (Vue, options) {
  var ToastConstructor = Vue.extend(_index.default);
  // 生成一个该子类的实例
  var instance = new ToastConstructor();
  instance.$mount(document.createElement('div'));
  document.body.appendChild(instance.$el);
  Vue.prototype.$modalCoupon = function (handle, keyNum) {
    var coupons = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var callback = arguments.length > 3 ? arguments[3] : undefined;
    var userIds = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
    var userType = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
    instance.visible = true;
    instance.handle = handle;
    instance.keyNum = keyNum;
    instance.coupons = coupons;
    instance.userIds = userIds;
    instance.callback = callback;
    instance.userType = userType;
  };
};
var _default = exports.default = couponFrom;